import React, { useState } from "react";
import YashLogo from "../images/Yash.svg";
import { HashLink as Link } from "react-router-hash-link";
export default function Navbar() {
  const [nav, setNav] = useState(false);
  window.onscroll = () => {
    window.scrollY >= 200 ? setNav(true) : setNav(false);
  };
  return (
    <>
      <nav
        className={"navbar fixed-top navbar-expand-lg navbar-light bg-white shadow"}
      >
        <div className="container nav_padding_md">
          <Link to="/" className="navbar-brand">
            <img
              src={YashLogo}
              className={!nav ? "nav_logo" : ""}
              alt="logo"
              width="34"
            />
          </Link>
          <button
            className="navbar-toggler"
            type="button"
            data-toggle="collapse"
            data-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>

          <div className="collapse navbar-collapse" id="navbarSupportedContent">
            <ul className="navbar-nav ml-auto font-family-medium">
              <li className="nav-item active">
                <Link className="nav-link" to="/#home">
                  Home <span className="sr-only">(current)</span>
                </Link>
              </li>
              <li className="nav-item">
                <Link to="/#about" className="nav-link">
                  About
                </Link>
              </li>
              <li className="nav-item">
                <Link to="/#skills" className="nav-link">
                  Skills
                </Link>
              </li>
              <li className="nav-item">
                <Link to="/#projects" className="nav-link">
                  Projects
                </Link>
              </li>
              <li className="nav-item">
                <Link to="/#contact" className="nav-link">
                  Contact
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    </>
  );
}
